<template>
  <div :class="$style.container">
    <component :is="currentIcon" />
  </div>
</template>

<script>
import ENIcon from 'atoms/icons/flags/EN';
import KGIcon from 'atoms/icons/flags/KG';
import KZIcon from 'atoms/icons/flags/KZ';
import RUIcon from 'atoms/icons/flags/RU';
import UZIcon from 'atoms/icons/flags/UZ';

const COUNTRIES_MAP = {
  EN: ENIcon,
  KG: KGIcon,
  KZ: KZIcon,
  RU: RUIcon,
  UZ: UZIcon,
};

export default {
  name: 'CountryFlag',
  components: {
    ENIcon,
    KGIcon,
    KZIcon,
    RUIcon,
    UZIcon,
  },
  props: {
    languageCode: {
      type: String,
      required: true,
    },
  },
  computed: {
    currentIcon() {
      return COUNTRIES_MAP[this.languageCode];
    },
  },
};
</script>

<style lang="sass" module>
  .container
    width: 24px
    height: 24px
    display: flex
    overflow: hidden
    border-radius: 50%
</style>
